import type { PositionMultiplicity } from '@entities/mto';
import { fmtNum, multiplicityLabel } from '@entities/mto';
import { MultNoteBox } from '../styles';

/** Строка «на 1 …»: «×16 = 27,2» и откуда число конструкций; числа нет — что
 *  сделать. Кратность, указанная снабженцем, — «×16 = 27,2 · указано вами».
 *  Полное пояснение — во всплывающей подсказке. */
export function MultNote({
  m,
  manual,
  total,
}: {
  m: PositionMultiplicity | undefined;
  manual?: number;
  total: string | null;
}) {
  if (manual != null && total != null) {
    return (
      <MultNoteBox $found title="Кратность указана снабженцем">
        <strong>
          ×{fmtNum(manual)} = {total}
        </strong>
        <div>указано вами</div>
      </MultNoteBox>
    );
  }
  if (!m) return null;
  const found = m.status === 'found' && total != null;
  return (
    <MultNoteBox $found={found} title={`Кратность по РД: ${multiplicityLabel(m)}`}>
      {found ? (
        <>
          <strong>
            ×{fmtNum(m.factor ?? null)} = {total}
          </strong>
          {m.source && <div>{m.source}</div>}
        </>
      ) : (
        multiplicityLabel(m)
      )}
    </MultNoteBox>
  );
}
